// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3RmOl","tab":"ProcedureTabs_tab__2A6B7"};